import { Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PreFilterContainer = styled(Box)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
}));

export const ScenarioText = styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    color: theme.palette.error.dark,
}));

export const ToggleButton = styled(IconButton)(({ theme }) => ({
    padding: theme.spacing(0.5),
    color: theme.palette.error.dark,
    '&:hover': {
        backgroundColor: theme.palette.error.light,
    },
}));

export const ConditionsContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(1),
    '& > *:not(:last-child)': {
        marginBottom: theme.spacing(2),
    },
}));

export const ScenarioPromptTag = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'component',
})<{ component?: string }>(({ theme }) => ({
    backgroundColor: '#FFFFFF',
    color: 'black',
    padding: theme.spacing(0.25, 1.5),
    borderRadius: '4px',
    border: '0.5px solid lightgray',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: 400,
    fontSize: '0.8rem',
    display: 'inline-block',
    '&:hover': {
        textDecoration: 'none',
    },
}));
